import React, { useEffect, useState } from 'react'
import { loadTalent, loadTalents } from '../utils/Network';
import TalentContent from './TalentContent';
import TalentDocumentsWidget from './talent/widgets/TalentDocumentsWidget';
import TalentQuestionsWidget from './talent/widgets/TalentQuestionsWidget';
import TalentChildrenWidget from './talent/widgets/TalentChildrenWidget';
import TalentAcademyCoursesWidget from './talent/widgets/TalentAcademyCoursesWidget';
import { getDefaultName } from '../utils';
import TabsWidget from './shared/dashboard/widgets/TabsWidget';

export default function TalentCategoryDetailsContent({ id }) {
    const isNew = !id || id === 'new';
    const talentId = isNew ? null : id;
    const [activeTab, setActiveTab] = useState('form');
    const [talent, setTalent] = useState(null);
    const [hasChildTalents, setHasChildTalents] = useState(false);

    useEffect(() => {
        if (!talentId) {
            setTalent(null);
            setHasChildTalents(false);
            return;
        }
        loadTalent(talentId).then((item) => setTalent(item));
    }, [talentId]);

    useEffect(() => {
        if (!talentId) {
            setHasChildTalents(false);
            return;
        }
        loadTalents().then((talents) => {
            const childs = (talents || []).filter((item) => item.parent == talentId);
            setHasChildTalents(childs.length > 0);
        });
    }, [talentId]);

    useEffect(() => {
        if (activeTab === 'academy_course' && hasChildTalents) {
            setActiveTab('form');
        }
    }, [activeTab, hasChildTalents]);

    const tabs = [
        { key: 'form', label: isNew ? 'Form' : (getDefaultName(talent?.names) || 'Form'), icon: 'fa-edit' },
        ...(!isNew ? [
            { key: 'documents', label: 'Document', icon: 'fa-file-text-o' },
            { key: 'questions', label: 'Questions', icon: 'fa-question-circle' },
            ...(!hasChildTalents ? [{ key: 'academy_course', label: 'Course', icon: 'fa-graduation-cap' }] : []),
        ] : []),
    ];

    const backHref = talent?.parent ? `/cms/talents/${talent.parent}` : '/cms/talents';

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <a href={backHref} title="Back to Talents" style={{ color: 'inherit', lineHeight: 1 }}>
                        <i className="fa fa-arrow-left" style={{ color: '#ffffff', fontSize: '16px' }} />
                    </a>
                    <h3 className="box-title mb-10 " style={{ marginTop: '10px' }}>{isNew ? 'Add Category' : getDefaultName(talent?.names)}</h3>
                </div>
            </section>

            <section className="content">
                <div className="container">
                    {!isNew && (
                        <div className="" style={{ marginBottom: 16 }}>
                           
                            <TalentChildrenWidget talentId={talentId} />
                        </div>
                    )}
                    <TabsWidget
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={setActiveTab}
                        className="cms-page-tabs"
                    />
                    <div className="cms-page-tab-content">
                        {activeTab === 'form' && (
                            <TalentContent id={talentId} />
                        )}
                        {!isNew && activeTab === 'documents' && (
                            <TalentDocumentsWidget talentId={talentId} />
                        )}
                        {!isNew && activeTab === 'questions' && (
                            <TalentQuestionsWidget talentId={talentId} />
                        )}
                        {!isNew && activeTab === 'academy_course' && !hasChildTalents && (
                            <TalentAcademyCoursesWidget talentId={talentId} />
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}
